//- 接口
var apiCore = {
  list:"/admin/student/listForPage",
	lecturerAlbumList:"/api/course/api/share/shareLecturerData",
	noShareCourse:'/api/course/wap/openCourseDetails',//公开课首页
	shareCourse:'/api/course/api/share/shareCourseData',//分享公开课首页
	openCourseCategory:'/api/course/wap/openCourseCategory',//公开课分类列表
	coursePageList:'/api/course/wap/openCoursePage',//公开课列表
	logins:'/api/uc/wap/user/login',//登录
	Authentication:'/api/course/wap/zhifu/getMissingInfo',//是否认证
	userWapByPhoneLogin:'/api/uc/wap/user/login/loginUserWapByPhone',//仅手机登录-无需密码

	invoiceAdds:'/api/v1/cms/sync/wap/addInvoice',//保存发票信息
	invoiceAdd:'/api/course/wap/zhifu/addInvoiceInfo',//保存发票信息
	getPayment:'/api/course/wap/zhifu/getPrepaid',//获取支付订单
	zeroOrder:'/api/course/wap/zhifu/addPrepaidZero',//获取0元订单

	getPaymentContinueEducation:'/api/course/wap/zhifu/getSettingPrepaid',//获取支付订单 配置学习时间范围
	getPaymentContinueEducationEndTime:'/api/course/wap/zhifu/getByStartTime',//获取支付订单 配置学习时间范围 获取结束时间


	zf:'/api/course/wap/zhifu/toPayPage',//支付订单
	zfhy:'/api/v1/cms/sync/wap/appToPay',//支付会员订单

	findLatestInvoiceInfo:'/api/v1/cms/sync/wap/findLatestInvoiceInfo',//开票前查询最新的发票信息

	addIntentUser:'/api/v1/cms/sync/intentUser/addIntentUser',//客户信息提交




	getSmsCode:'/api/uc/wap/user/login/getSmsCodeLogin',//获取验证码
	yzmLogin:'/api/uc/wap/user/login/sms',//验证码登录


	homePage:'/api/course/wap/courseIndex',
	commentData:'/api/uc/commentCourse/shareCourseCommentData',//留言
	helpList:'/api/msg/api/help/list',//用户帮助列表
	helpDetails:'/api/msg/api/help/detail',//用户帮助列表
	messageDetails:'/api/msg/api/message/detail',//用户帮助列表
	educationType:'/admin/dict/listByDictType/educationType', //教育类型


	getEducationType:'/api/course/wap/zhifu/getEducationType',//wap获取教育类型
	getSubsystem:'/api/course/wap/zhifu/getSubsystem',//wap查询子系统列表
	getAreaListInfo:'/api/course/wap/zhifu/getAreaListInfo',//wap获取城市（只有有子系统的城市才会列出）
	getAppIsFee:'/api/course/wap/zhifu/getAppIsFee',//wap 判断是否可以去支付

	// https://api-dev.jt11.com.cn/api/course
	findPreOrder:'/api/v1/cms/sync/wap/findPreOrder',//查看缴费时间

	syncStudent:'/admin/third/syncStudent',//第三方接口请求
	query:'/api/course/wechat/api/enroll/list',//查询接口
	signUp:'/api/course/wechat/api/enroll/add',//报名接口
	saveCfStudent:'/admin/third/saveCfStudent',//报名接口
	saveWfStudent:'/admin/third/saveWfStudent',//潍坊报名接口
    saveHzStudent:'/admin/third/saveHzStudent',//菏泽报名接口

    saveSxxyStudent:'/admin/third/saveSxxyStudent',//山西孝义
	saveCjStudent:'/admin/third/saveCjStudent',//昌吉签到报名接口
	saveUnifiedRegistration:'/admin/third/saveUnifiedRegistration',//统一注册

	saveVdaMain:'/admin/third/vdaMain/add',//车辆/驾驶员档案保存
	getVdaMain:'/admin/third/vdaMain/getInfoByPhone',//车辆/驾驶员档案保存

	listForIndustryType:'/api/course/wechat/api/enroll/listForIndustryType',//行业类别接口
	listForEnroll:'/api/course/wechat/api/enroll/listForEnroll',//获取第三方的用户信息

	queryCarDetail:'/api/safe//carManageApi/getCarManageApiDetails',//扫码获取车车牌详情


}
//配置API接口地址
window.Global.apiCore = apiCore;
